module.exports = __webpack_public_path__ + "img/icon-word.def822ed.png";